<template>
  <div class="vue-admin-beautiful-wrapper" :class="classObj">
    <div
      v-if="'horizontal' === layout"
      class="layout-container-horizontal"
      :class="{
        fixed: header === 'fixed',
        'no-tabs-bar': tabsBar === 'false' || tabsBar === false,
      }"
    >
      <div :class="header === 'fixed' ? 'fixed-header' : ''">
        <vab-top-bar />
        <div
          v-if="tabsBar === 'true' || tabsBar === true"
          :class="{ 'tag-view-show': tabsBar }"
        >
          <div class="vab-main">
            <vab-tabs-bar />
          </div>
        </div>
      </div>
      <div class="vab-main main-padding">
        <!-- <vab-ad /> -->
        <vab-app-main />
      </div>
    </div>
    <div
      v-else
      class="layout-container-vertical"
      :class="{
        fixed: header === 'fixed',
        'no-tabs-bar': tabsBar === 'false' || tabsBar === false,
      }"
    >
      <div
        v-if="device === 'mobile' && collapse === false"
        class="mask"
        @click="handleFoldSideBar"
      />
      <div id="solid_left">
        <sildBar />
      </div>

      <div class="vab-main" :class="collapse ? 'is-collapse-main' : ''">
        <div :class="header === 'fixed' ? 'fixed-header' : ''">
          <vab-nav-bar />

          <!-- <vab-tabs-bar v-if="tabsBar === 'true' || tabsBar === true" /> -->
        </div>
        <vab-app-main />
      </div>
    </div>
    <el-backtop />
  </div>
</template>

<script>
  import { Index_order_num } from '@/api/xgcApi'
  import { mapActions, mapGetters } from 'vuex'
  import { tokenName } from '@/config'
  import sildBar from '../components/VabSideBar/index.vue'
  import $ from 'jquery' // 引入jQuery
  import { Number } from 'core-js/web/timers'
  export default {
    name: 'Layout',
    components: { sildBar },
    data() {
      return {
        oldLayout: '',
        time: null,
        // 浏览器消息通知 - 上一次轮询的代买/代付数量(用于对比,只在数量增加时弹通知,避免重复打扰)
        lastNoticeBuyKor: 0,
        lastNoticeBuyBehalfPay: 0,
        lastpurchaseOnBehalfCount: 0,

        // 浏览器消息通知 是否已经向用户申请过授权
        noticePermissionRequested: false,
      }
    },
    computed: {
      ...mapGetters({
        layout: 'settings/layout',
        tabsBar: 'settings/tabsBar',
        collapse: 'settings/collapse',
        header: 'settings/header',
        device: 'settings/device',
      }),
      classObj() {
        return {
          mobile: this.device === 'mobile',
        }
      },
    },
    beforeMount() {
      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
      if (this.time) {
        clearInterval(this.time)
        this.time = null
      }
    },
    mounted() {
      let left = $('#solid_left')

      let bar_item = left.find('.el-menu-item')
      let bar_item_title = left.find('.el-submenu .el-submenu__title')
      bar_item.each((index, item) => {
        bar_item
          .eq(index)
          .append(`<span style="color:red;margin-left:5px;"></span>`)
        var span = bar_item.eq(index).find('span')
      })
      bar_item_title.each((index, item) => {
        bar_item_title
          .eq(index)
          .append(
            `<span style="color:red;font-size:28px;margin-left:5px;" ></span>`
          )
        var span = bar_item_title.eq(index).find('span')
      })
      this.time = setInterval(() => {
        this.loop()
      }, 7000)

      this.oldLayout = this.layout
      const userAgent = navigator.userAgent
      if (userAgent.includes('Juejin')) {
        this.$baseAlert(
          'vue-admin-beautiful不支持在掘金内置浏览器演示，请手动复制以下地址到浏览器中查看http://mpfhrd48.sanxing.uz7.cn/vue-admin-beautiful'
        )
      }
      const isMobile = this.handleIsMobile()
      if (isMobile) {
        if (isMobile) {
          //横向布局时如果是手机端访问那么改成纵向版
          this.$store.dispatch('settings/changeLayout', 'vertical')
        } else {
          this.$store.dispatch('settings/changeLayout', this.oldLayout)
        }
        this.$store.dispatch('settings/toggleDevice', 'mobile')
        setTimeout(() => {
          this.$store.dispatch('settings/foldSideBar')
        }, 2000)
      } else {
        this.$store.dispatch('settings/openSideBar')
      }
      this.$nextTick(() => {
        window.addEventListener(
          'storage',
          (e) => {
            if (e.key === tokenName || e.key === null) window.location.reload()
            if (e.key === tokenName && e.value === null)
              window.location.reload()
          },
          false
        )
      })
      // 进入页面后主动请求一次浏览器通知权限(浏览器会弹出"是否允许通知")
      this.requestNotificationPermission()
    },
    methods: {
      ...mapActions({
        handleFoldSideBar: 'settings/foldSideBar',
      }),
      loop() {
        let left = $('#solid_left')
        let bar_item = left.find('.el-menu-item')
        let bar_item_title = left.find('.el-submenu .el-submenu__title')

        let data = {
          orderListTime_k: localStorage.getItem('orderListTime_k')
            ? Number(localStorage.getItem('orderListTime_k'))
            : 0,
          orderListTime_J: localStorage.getItem('orderListTime_J')
            ? Number(localStorage.getItem('orderListTime_J'))
            : 0,
          buy_list_time_k: localStorage.getItem('buy_list_time_k')
            ? Number(localStorage.getItem('buy_list_time_k'))
            : 0,
          buy_list_time_J: localStorage.getItem('buy_list_time_J')
            ? Number(localStorage.getItem('buy_list_time_J'))
            : 0,
          buy_list_time_D: localStorage.getItem('buy_list_time_D')
            ? Number(localStorage.getItem('buy_list_time_D'))
            : 0,
          goods_list_time: localStorage.getItem('goods_list_time')
            ? Number(localStorage.getItem('goods_list_time'))
            : 0,
          reshoot_goods_time: localStorage.getItem('reshoot_goods_time')
            ? Number(localStorage.getItem('reshoot_goods_time'))
            : 0,
          kor_order_list_time: localStorage.getItem('kor_order_list_time')
            ? Number(localStorage.getItem('kor_order_list_time'))
            : 0,
          goods_photo_list_time: localStorage.getItem('goods_photo_list_time')
            ? Number(localStorage.getItem('goods_photo_list_time'))
            : 0,
          claim_list_time: localStorage.getItem('claim_list_time')
            ? Number(localStorage.getItem('claim_list_time'))
            : 0,
            purchase_on_behalf_time: localStorage.getItem('purchase_on_behalf_time')
            ? Number(localStorage.getItem('purchase_on_behalf_time'))
            : 0,
        }
        Index_order_num(data).then((res) => {
          var korTochn = res.data[0]
          var korTojpn = res.data[3]
          var korTomas = res.data[4]
          var chnTomas = res.data[5]
          bar_item_title.each((index, item) => {
            let span = bar_item_title.eq(index).find('span')
            let item_title = span[0].innerHTML
            if (item_title == '韩/日到中') {
              if (
                korTochn.order_jep > 0 ||
                korTochn.order_kor > 0 ||
                korTochn.buy_jep > 0 ||
                korTochn.buy_kor > 0 ||
                korTochn.buy_behalf_pay > 0 ||
                korTochn.goods_order_num > 0 ||
                korTochn.reshoot_goods_order_num > 0 ||
                korTochn.claim_num > 0 ||
                korTochn.purchase_on_behalf_count > 0 ||

                korTojpn.order_jep > 0 ||
                korTojpn.order_kor > 0 ||
                korTojpn.buy_jep > 0 ||
                korTojpn.buy_kor > 0 ||
                korTojpn.buy_behalf_pay > 0 ||
                korTojpn.goods_order_num > 0 ||
                korTojpn.reshoot_goods_order_num > 0 ||
                korTojpn.claim_num > 0 ||
                korTomas.order_jep > 0 ||
                korTomas.order_kor > 0 ||
                korTomas.buy_jep > 0 ||
                korTomas.buy_kor > 0 ||
                korTomas.buy_behalf_pay > 0 ||
                korTomas.goods_order_num > 0 ||
                korTomas.reshoot_goods_order_num > 0 ||
                korTomas.claim_num > 0 ||
                chnTomas.order_jep > 0 ||
                chnTomas.order_kor > 0 ||
                chnTomas.buy_jep > 0 ||
                chnTomas.buy_kor > 0 ||
                chnTomas.buy_behalf_pay > 0 ||
                chnTomas.goods_order_num > 0 ||
                chnTomas.reshoot_goods_order_num > 0 ||
                chnTomas.claim_num > 0
              ) {
                span.eq(1).text(`●`)
                // span.eq(1).attr("style", "line-height:5px; margin-left:5px; background: red;borde;padding:0 8px;border-radius: 15px;");
                span.eq(1).attr('style', 'color:red;margin-left:5px;')
              } else {
                span.eq(1).attr('style', '')
                span.eq(1).text(``)
              }
            }

            // 中到韩物流小红点提示
            if (item_title == '中到韩') {
              if (
                korTochn.kor_order > 0 ||
                korTojpn.kor_order > 0 ||
                korTomas.kor_order > 0 ||
                chnTomas.kor_order > 0
              ) {
                span.eq(1).text(`●`)
                span.eq(1).attr('style', 'color:red;margin-left:5px;')
              } else {
                span.eq(1).attr('style', '')
                span.eq(1).text(``)
              }
            }

            if (item_title == '韩到马来') {
              if (
                korTomas.order_jep > 0 ||
                korTomas.order_kor > 0 ||
                korTomas.buy_jep > 0 ||
                korTomas.buy_kor > 0 ||
                korTomas.buy_behalf_pay > 0 ||
                korTomas.goods_order_num > 0 ||
                korTomas.reshoot_goods_order_num > 0 ||
                korTomas.claim_num > 0
              ) {
                span.eq(1).text(`●`)
                span.eq(1).attr('style', 'color:red;margin-left:5px;')
              } else {
                span.eq(1).attr('style', '')
                span.eq(1).text(``)
              }
            }
            if (item_title == '韩到日物流') {
              if (
                korTojpn.order_jep > 0 ||
                korTojpn.order_kor > 0 ||
                korTojpn.buy_jep > 0 ||
                korTojpn.buy_kor > 0 ||
                korTojpn.buy_behalf_pay > 0 ||
                korTojpn.goods_order_num > 0 ||
                korTojpn.reshoot_goods_order_num > 0 ||
                korTojpn.claim_num > 0
              ) {
                span.eq(1).text(`●`)
                span.eq(1).attr('style', 'color:red;margin-left:5px;')
              } else {
                span.eq(1).attr('style', '')
                span.eq(1).text(``)
              }
            }
            if (item_title == '中到马来') {
              console.log(chnTomas, '----')
              if (
                chnTomas.order_jep > 0 ||
                chnTomas.order_kor > 0 ||
                chnTomas.buy_jep > 0 ||
                chnTomas.buy_kor > 0 ||
                chnTomas.buy_behalf_pay > 0 ||
                chnTomas.goods_order_num > 0 ||
                chnTomas.reshoot_goods_order_num > 0 ||
                chnTomas.claim_num > 0
              ) {
                span.eq(1).text(`●`)
                span.eq(1).attr('style', 'color:red;margin-left:5px;')
              } else {
                span.eq(1).attr('style', '')
                span.eq(1).text(``)
              }
            }

            // 代买代付小红点提示
            if (item_title == '代买代付管理') {
              if (
                korTochn.buy_jep > 0 ||
                korTojpn.buy_jep > 0 ||
                korTomas.buy_jep > 0 ||
                chnTomas.buy_jep > 0 ||
                korTochn.buy_kor > 0 ||
                korTojpn.buy_kor > 0 ||
                korTomas.buy_kor > 0 ||
                chnTomas.buy_kor > 0
              ) {
                span.eq(1).text(`●`)
                span.eq(1).attr('style', 'color:red;margin-left:5px;')
              } else {
                span.eq(1).attr('style', '')
                span.eq(1).text(``)
              }
            }
          })

          bar_item.each((index, item) => {
            let span = bar_item.eq(index).find('span')
            let item_title = span[0].innerHTML
            if (item_title == '代买订单(韩)') {
              if (korTochn.buy_kor > 0) {
                span.eq(1).text(`(${korTochn.buy_kor})`)
              } else {
                span.eq(1).text('')
              }
            }
            if (item_title == '拍照订单') {
              if (korTochn.goods_photo_num > 0) {
                span.eq(1).text(`(${korTochn.goods_photo_num})`)
              } else {
                span.eq(1).text('')
              }
            }
            if (item_title == '待认领包裹') {
              if (korTochn.claim_num > 0) {
                span.eq(1).text(`(${korTochn.claim_num})`)
              } else {
                span.eq(1).text('')
              }
            }

            if (item_title == '日区代买管理') {
              if (korTochn.buy_jep > 0) {
                span.eq(1).text(`(${korTochn.buy_jep})`)
              } else {
                span.eq(1).text('')
              }
            }
            if (item_title == '韩国包裹管理') {
              if (korTochn.order_kor > 0) {
                span.eq(1).text(`(${korTochn.order_kor})`)
              } else {
                span.eq(1).text('')
              }
            }
            if (item_title == '包裹列表') {
              if (korTomas.order_kor > 0) {
                span.eq(1).text(`(${korTomas.order_kor})`)
              } else {
                span.eq(1).text('')
              }
            }

            if (item_title == '中到马来包裹') {
              if (chnTomas.order_kor > 0) {
                span.eq(1).text(`(${chnTomas.order_kor})`)
              } else {
                span.eq(1).text('')
              }
            }

            if (item_title == '韩到日包裹') {
              if (korTojpn.order_kor > 0) {
                span.eq(1).text(`(${korTojpn.order_kor})`)
              } else {
                span.eq(1).text('')
              }
            }
            if (item_title == '日本包裹管理') {
              if (korTochn.order_jep > 0) {
                span.eq(1).text(`(${korTochn.order_jep})`)
              } else {
                span.eq(1).text('')
              }
            }

            if (item_title == '代付订单(韩)') {
              if (korTochn.buy_behalf_pay > 0) {
                span.eq(1).text(`(${korTochn.buy_behalf_pay})`)
              } else {
                span.eq(1).text('')
              }
            }
            if (item_title == '中到马来代付') {
              if (chnTomas.buy_behalf_pay > 0) {
                span.eq(1).text(`(${chnTomas.buy_behalf_pay})`)
              } else {
                span.eq(1).text('')
              }
            }
            if (item_title == '韩到马来代付') {
              if (korTomas.buy_behalf_pay > 0) {
                span.eq(1).text(`(${korTomas.buy_behalf_pay})`)
              } else {
                span.eq(1).text('')
              }
            }
            if (item_title == '韩到日代付') {
              if (korTojpn.buy_behalf_pay > 0) {
                span.eq(1).text(`(${korTojpn.buy_behalf_pay})`)
              } else {
                span.eq(1).text('')
              }
            }

            if (item_title == '中到马来代买') {
              if (chnTomas.buy_kor > 0) {
                span.eq(1).text(`(${chnTomas.buy_kor})`)
              } else {
                span.eq(1).text('')
              }
            }
            if (item_title == '韩到马来代买') {
              if (korTomas.buy_kor > 0) {
                span.eq(1).text(`(${korTomas.buy_kor})`)
              } else {
                span.eq(1).text('')
              }
            }
            if (item_title == '韩到日代买') {
              if (korTojpn.buy_kor > 0) {
                span.eq(1).text(`(${korTojpn.buy_kor})`)
              } else {
                span.eq(1).text('')
              }
            }
            if (item_title == '韩到中商品订单') {
              if (korTochn.goods_order_num > 0) {
                span.eq(1).text(`(${korTochn.goods_order_num})`)
              } else {
                span.eq(1).text(``)
              }
            }

            if (item_title == '韩到日商品订单') {
              if (korTojpn.goods_order_num > 0) {
                span.eq(1).text(`(${korTojpn.goods_order_num})`)
              } else {
                span.eq(1).text(``)
              }
            }
            if (item_title == '韩到马来商品订单') {
              if (korTomas.goods_order_num > 0) {
                span.eq(1).text(`(${korTomas.goods_order_num})`)
              } else {
                span.eq(1).text(``)
              }
            }
            if (item_title == '中到马来商品订单') {
              if (chnTomas.goods_order_num > 0) {
                span.eq(1).text(`(${chnTomas.goods_order_num})`)
              } else {
                span.eq(1).text(``)
              }
            }
            if (item_title == '韩到日补价订单') {
              if (korTojpn.reshoot_goods_order_num > 0) {
                span.eq(1).text(`(${korTojpn.reshoot_goods_order_num})`)
              } else {
                span.eq(1).text(``)
              }
            }
            if (item_title == '中到马来补价订单') {
              if (chnTomas.reshoot_goods_order_num > 0) {
                span.eq(1).text(`(${chnTomas.reshoot_goods_order_num})`)
              } else {
                span.eq(1).text(``)
              }
            }
            if (item_title == '韩到马来补价订单') {
              if (korTomas.reshoot_goods_order_num > 0) {
                span.eq(1).text(`(${korTomas.reshoot_goods_order_num})`)
              } else {
                span.eq(1).text(``)
              }
            }
            if (item_title == '补价订单') {
              if (korTochn.reshoot_goods_order_num > 0) {
                span.eq(1).text(`(${korTochn.reshoot_goods_order_num})`)
              } else {
                span.eq(1).text(``)
              }
            }
            // if (item_title == '韩国包裹管理') {
            //   if (korTochn.kor_order > 0) {
            //     span.eq(1).text(`(${korTochn.kor_order})`)
            //   } else {
            //     span.eq(1).text('')
            //   }
            // }
          })

          // 右下角弹窗:代买/代付订单数量提示
          // 取韩到中这一组数据的 buy_kor(代买)、buy_behalf_pay(代付)
          const buyKorNum = Number(korTochn.buy_kor) || 0
          const buyBehalfPayNum = Number(korTochn.buy_behalf_pay) || 0
          const purchaseOnBehalfCount = Number(korTochn.purchase_on_behalf_count) || 0

          // 仅当本次数量比上一次多(新订单到来)时,弹出浏览器系统通知
          if (
            buyKorNum > this.lastNoticeBuyKor ||
            buyBehalfPayNum > this.lastNoticeBuyBehalfPay ||
            purchaseOnBehalfCount > this.lastpurchaseOnBehalfCount
          ) {
            this.showBrowserNotice(buyKorNum, buyBehalfPayNum,purchaseOnBehalfCount)
          }
          this.lastNoticeBuyKor = buyKorNum
          this.lastNoticeBuyBehalfPay = buyBehalfPayNum
          this.lastpurchaseOnBehalfCount = purchaseOnBehalfCount
        })
      },
      // 请求浏览器通知权限(只请求一次)
      requestNotificationPermission() {
        if (!('Notification' in window)) {
          this.$baseMessage('当前浏览器不支持消息通知', 'warning')
          return
        }
        if (this.noticePermissionRequested) return
        this.noticePermissionRequested = true
        if (
          Notification.permission === 'default' ||
          Notification.permission === 'denied'
        ) {
          Notification.requestPermission().catch(() => {})
        }
      },
      // 弹出 Chrome 浏览器系统通知
      showBrowserNotice(buyKorNum, buyBehalfPayNum, purchaseOnBehalfCount) {
        if (!('Notification' in window)) {
          this.$baseMessage('当前浏览器不支持消息通知', 'warning')
          return
        }
        if (Notification.permission !== 'granted') {
          // 没有授权时静默请求一次授权(用户首次操作后再授权才会真正显示)
          this.requestNotificationPermission()
          return
        }
        const title = '新订单提醒'
        const body = `代买:${buyKorNum},代付:${buyBehalfPayNum},代买已支付:${purchaseOnBehalfCount}`
        try {
          const notification = new Notification(title, {
            body,
            icon: '/favicon.ico',
            tag: 'order-notice',
            renotify: true,
          })
          // 点击通知 -> 跳转到代买管理页
          notification.onclick = () => {
            window.focus()
            this.$router
              .push('/parcelManagement/manageBuyPay/index')
              .catch(() => {})
            notification.close()
          }
          // 8 秒后自动关闭
          setTimeout(() => notification.close(), 8000)
        } catch (e) {
          // 部分浏览器(老 Safari 等)需要通过 ServiceRegistration 注册后使用,这里兜底降级为页内提示
          this.$baseNotify({
            title: '新订单提醒',
            message: body,
            position: 'bottom-right',
            duration: 6000,
          })
        }
      },
      handleIsMobile() {
        return document.body.getBoundingClientRect().width - 1 < 992
      },
      handleResize() {
        if (!document.hidden) {
          const isMobile = this.handleIsMobile()
          if (isMobile) {
            //横向布局时如果是手机端访问那么改成纵向版
            this.$store.dispatch('settings/changeLayout', 'vertical')
          } else {
            this.$store.dispatch('settings/changeLayout', this.oldLayout)
          }
          this.$store.dispatch(
            'settings/toggleDevice',
            isMobile ? 'mobile' : 'desktop'
          )
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  @mixin fix-header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: $base-z-index - 2;
    width: 100%;
    overflow: hidden;
  }

  .vue-admin-beautiful-wrapper {
    position: relative;
    width: 100%;
    height: 100%;

    .layout-container-horizontal {
      position: relative;

      // &.fixed {
      //   padding-top: calc(#{$base-top-bar-height} + #{$base-tabs-bar-height});
      // }
      &.fixed {
        padding-top: calc(#{$base-top-bar-height});
      }

      &.fixed.no-tabs-bar {
        padding-top: $base-top-bar-height;
      }

      ::v-deep {
        .vab-main {
          width: 100%;
          margin: auto;
        }

        .fixed-header {
          @include fix-header;
        }

        .tag-view-show {
          background: $base-color-white;
          box-shadow: $base-box-shadow;
        }

        .nav-bar-container {
          .fold-unfold {
            display: none;
          }
        }

        .main-padding {
          .app-main-container {
            // margin-top: $base-padding;
            margin-bottom: $base-padding;
            background: $base-color-white;
          }
        }
      }
    }

    .layout-container-vertical {
      position: relative;

      .mask {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: $base-z-index - 1;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        background: #000;
        opacity: 0.5;
      }
      // &.fixed {
      //   padding-top: calc(#{$base-nav-bar-height} + #{$base-tabs-bar-height});
      // }

      &.fixed {
        padding-top: calc(#{$base-nav-bar-height});
      }

      &.fixed.no-tabs-bar {
        padding-top: $base-nav-bar-height;
      }

      .vab-main {
        position: relative;
        min-height: 100%;
        margin-left: $base-left-menu-width;
        background: #f6f8f9;
        transition: $base-transition;

        ::v-deep {
          .fixed-header {
            @include fix-header;

            left: $base-left-menu-width;
            width: $base-right-content-width;
            box-shadow: $base-box-shadow;
            transition: $base-transition;
          }

          .nav-bar-container {
            position: relative;
            box-sizing: border-box;
          }

          .tabs-bar-container {
            box-sizing: border-box;
          }

          .app-main-container {
            // width: calc(100% - #{$base-padding} - #{$base-padding});
            width: calc(100%);
            // margin: $base-padding auto;
            background: $base-color-white;
            border-radius: $base-border-radius;
          }
        }

        &.is-collapse-main {
          margin-left: $base-left-menu-width-min;

          ::v-deep {
            .fixed-header {
              left: $base-left-menu-width-min;
              width: calc(100% - 65px);
            }
          }
        }
      }
    }

    /* 手机端开始 */
    &.mobile {
      ::v-deep {
        .el-pager,
        .el-pagination__jump {
          display: none;
        }

        .layout-container-vertical {
          .el-scrollbar.side-bar-container.is-collapse {
            width: 0;
          }

          .vab-main {
            width: 100%;
            margin-left: 0;
          }
        }

        .vab-main {
          .fixed-header {
            left: 0 !important;
            width: 100% !important;
          }
        }
      }
    }

    /* 手机端结束 */
  }
</style>
